import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Komponen ini otomatis scroll ke atas setiap kali route berubah.
 * Tidak menyebabkan render loop.
 */
export default function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        // Jika URL punya hash (#section), biarkan perilaku default smooth scroll
        if (hash) return;

        // Kalau berpindah halaman (bukan hash link), scroll ke atas
        window.scrollTo({
            top: 0,
            behavior: "smooth", // atau "smooth"
        });
    }, [pathname, hash]);

    return null;
}
